import { marketingAttributionEvent } from "@redotech/redo-model/marketing";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

const dailyRevenueMetricsRowSchema = z.object({
  DATE: z.date(),
  CAMPAIGN_REVENUE: z.number(),
  CAMPAIGN_SPEND: z.number(),
  AUTOMATION_REVENUE: z.number(),
  AUTOMATION_SPEND: z.number(),
  TOTAL_REVENUE: z.number(),
  TOTAL_SPEND: z.number(),
});

const dailyRevenueMetricsTotalsSchema = z.object({
  totalRevenue: z.number(),
  totalSpend: z.number(),
  totalROI: z.number(),
  previousTotalRevenue: z.number(),
  previousTotalSpend: z.number(),
  previousTotalROI: z.number(),
});

export const getDailyRevenueMetrics = {
  name: "getDailyRevenueMetrics" as const,
  input: z.object({
    startDate: zExt.instant(),
    endDate: zExt.instant(),
    attributionDays: z.number().min(1).max(30).optional().default(5),
    channels: z.array(createEnum(["email", "sms"])).optional(),
    attributionEvents: z
      .array(createEnum(Object.values(marketingAttributionEvent)))
      .optional(),
  }),
  output: z.object({
    dailyMetrics: z.array(dailyRevenueMetricsRowSchema),
    totals: dailyRevenueMetricsTotalsSchema,
  }),
};
